import { HOME_LINK_CLASS } from 'pages/home/HomeSection';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { cn } from 'utils/cn';
import { FigureLink, Headline, KpiFormProps, VALUE_CLASS } from './KpiParts';
import { widgetListLabel } from './widgetLink';

/** The rows of the two-row size; the four-row one shows every row the figure holds. */
const SHORT_ROWS = 5;

/**
 * The largest records by the measure. A row's name opens the record and its value the list narrowed to it. The tall
 * size shows more rows, each with its second line where the figure gives one, and ends in a link to the whole list.
 * A name keeps 64px beside a value in full; a value that leaves it less is written short, and the name takes the rest.
 */
export function RankedForm({ definition, figure, size, links, format }: KpiFormProps) {
    const intl = useIntl();
    const tall = size === '1x4';
    const rows = tall ? (figure.rows ?? []) : (figure.rows ?? []).slice(0, SHORT_ROWS);
    const listLabel = widgetListLabel(definition);
    return (
        <>
            <ol className="flex min-h-0 flex-1 flex-col overflow-y-auto">
                {rows.map((row, index) => {
                    const sub = tall ? row.sub : undefined;
                    return (
                        <li
                            key={row.key}
                            className={cn(
                                'group/row border-divider-soft text-meta flex max-h-11 min-h-7 flex-1 items-center gap-2.5 border-t',
                                sub && 'min-h-9'
                            )}
                        >
                            <span className="text-muted-foreground w-4 shrink-0 tabular-nums">{index + 1}</span>
                            <span className="flex min-w-16 flex-1 flex-col group-has-[[data-short]]/row:min-w-0">
                                <FigureLink to={links?.record(row)} className="truncate font-medium">
                                    {row.label}
                                </FigureLink>
                                {sub ? (
                                    <span className="text-muted-foreground text-caption truncate">{sub}</span>
                                ) : null}
                            </span>
                            <Headline value={row.value} format={format} to={links?.row(row)} className={VALUE_CLASS} />
                        </li>
                    );
                })}
            </ol>
            {tall && links && listLabel ? (
                <div className="border-divider-soft flex h-[30px] shrink-0 items-center border-t">
                    <Link to={links.list} className={HOME_LINK_CLASS}>
                        <FormattedMessage
                            id="home.widgets.menu.open-in"
                            values={{ list: intl.formatMessage({ id: listLabel }) }}
                        />
                    </Link>
                </div>
            ) : null}
        </>
    );
}
